import { render, staticRenderFns } from "./PageContent.vue?vue&type=template&id=d6bb7c8c"
import script from "./PageContent.vue?vue&type=script&lang=js"
export * from "./PageContent.vue?vue&type=script&lang=js"
import style0 from "./PageContent.vue?vue&type=style&index=0&id=d6bb7c8c&prod&lang=stylus&module=attr"




function injectStyles (context) {
  
  this["attr"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderTemplate: require('/var/www/malayan/web/components/global/templates/HeaderTemplate.vue').default,InputTextTemplate: require('/var/www/malayan/web/components/global/templates/InputTextTemplate.vue').default,IconTemplate: require('/var/www/malayan/web/components/global/templates/IconTemplate.vue').default})
